var jsonData = {
  table_header:[
    '材料名',
    'ソフトウェア',
    '厚さ(mm)',
    'ライン間隔 / 品質',
    '加工方法',
    '速度(mm/分)',
    '最大出力 / S-Max',
    '画像モード',
    'パス回数'
  ],
  A20prov2: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 20000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "9mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 20000,
      max: 900,
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 120,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 20000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 20000,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 20000,
      max: 800,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 800,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "16mm",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: "80%",
      mode: "-",
      number: 6,
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "16mm",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 6,
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 3000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "4.5mm",
      quality: "-",
      processing: "カット",
      speed: 50,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 8000,
      max: 600,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "4.5mm",
      quality: "-",
      processing: "カット",
      speed: 50,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "800",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: 10000,
      max: 300,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 20000,
      max: "70%",
      mode: "Filled(One-way scanning)",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 20000,
      max: 700,
      mode: "Filled(One-way scanning)",
      number: 1,
    },
    {
      name: "油絵用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 20000,
      max: "40%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "油絵用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 20000,
      max: 400,
      mode: "Stucki",
      number: "-",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 20000,
      max: "80%",
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 20000,
      max: 800,
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 20000,
      max: "60%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "カット",
      speed: 250,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 20000,
      max: 600,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "カット",
      speed: 250,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "鏡面ステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 600,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "鏡面ステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 600,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 1000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 6000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 6000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 20000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 20000,
      max: 700,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 20000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 20000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "80%",
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 800,
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 650,
      max: "100%",
      mode: "-",
      number: 4,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 160,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 400,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 650,
      max: 1000,
      mode: "-",
      number: 4,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 160,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Filled",
      number: 1,
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 600,
      mode: "Filled",
      number: 1,
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "800",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "マホガニー材",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "マホガニー材",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 300,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: 500,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "樹脂",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 4000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "樹脂",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 4000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "人工牛骨",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "65%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "人工牛骨",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 650,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "人工瑪瑙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "人工瑪瑙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 500,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "石畳",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 6000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "石畳",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 6000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
  ],
  A10prov2: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 5000,
      max: "50%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 8,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 190,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 5000,
      max: 500,
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 8,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 190,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 6000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 8000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "10",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 80,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: 400,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 80,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: 6000,
      max: "60%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
    },
    {
      name: "油絵用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "5%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "油絵用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: 50,
      mode: "-",
      number: "1",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 8000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 300,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 6000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 300,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 400,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 400,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 2000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 5000,
      max: 600,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 6000,
      max: "20%",
      mode: "Atkinson",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 5000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 5000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 800,
      max: "65%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 800,
      max: "650",
      mode: "-",
      number: 1,
    },
    {
      name: "マホガニー材",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 6000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "マホガニー材",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 600,
      max: "20%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 600,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 5000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 5000,
      max: 300,
      mode: "-",
      number: 1,
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 5000,
      max: "35%",
      mode: "Threshold（ overscanning）",
      number: 1,
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 5000,
      max: 350,
      mode: "-",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 1000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 1000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "半透明アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "半透明アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "石畳",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 1000,
      max: "70%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "石畳",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 1000,
      max: 700,
      mode: "-",
      number: 1,
    },
  ],
  A40prov2: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "もち米紙",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "もち米紙",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],
  A70Max: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "1200",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "1200",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "25",
      quality: "-",
      processing: "カット",
      speed: "1100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "25",
      quality: "-",
      processing: "カット",
      speed: "1100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "2",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "350",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "900",
      mode: "-",
      number: "2",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "350",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "4",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "5",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "4",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "900",
      mode: "-",
      number: "5",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "55%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "550",
      mode: "-",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "26",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "26",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "半透明アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "半透明アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "13%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "130",
      mode: "-",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "9000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "9000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "9000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "9000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "27%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "270",
      mode: "-",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "12",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "9",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "11",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "12",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "9",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "60%",
      mode: "-",
      number: "1",
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "EVAフォーム",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "1500",
      max: "30%",
      mode: "-",
      number: "1",
    },
    {
      name: "EVAフォーム",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "1500",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "もち米紙",
      software: "LightBurn",
      thickness: "0.5",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "もち米紙",
      software: "LaserGRBL",
      thickness: "0.5",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "1.5",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "ウールブランケット",
      software: "LaserGRBL",
      thickness: "1.5",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "5000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "5000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "ハードメープル材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ハードメープル材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "彫刻",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "3000",
      max: "90%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "彫刻",
      speed: "3000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "2000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],
  A24Pro: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "17mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "800",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "650",
      max: "80%",
      mode: "-",
      number: "9",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "650",
      max: "800",
      mode: "-",
      number: "9",
    },
    {
      name: "桃の木材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "桃の木材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "マホガニー材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "マホガニー材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "60%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "3",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "3",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "2",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "2",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "25mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "25mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "半透明アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "20%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "半透明アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "-",
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "20%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "油絵用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "40%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "油絵用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "400",
      mode: "-",
      number: "-",
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "50%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],

  A40Pro: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "もち米紙",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "もち米紙",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],

  A40max: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "カット",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "カット",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "もち米紙",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "もち米紙",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "彫刻",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVAフォーム",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "石膏ボード",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "彫刻",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "ウールブランケット",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "カット",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "彫刻",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],

  A24Ultra: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "17mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "800",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "650",
      max: "80%",
      mode: "-",
      number: "9",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "650",
      max: "800",
      mode: "-",
      number: "9",
    },
    {
      name: "桃の木材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "桃の木材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "マホガニー材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "マホガニー材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "60%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "3",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "3",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "2",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "2",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "25mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "25mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "半透明アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "20%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "半透明アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "-",
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "20%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "油絵用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "40%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "油絵用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "400",
      mode: "-",
      number: "-",
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "30000",
      max: "50%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "30000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],

  A70Pro: [
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "1200",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "1200",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "バスウッド",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "25",
      quality: "-",
      processing: "カット",
      speed: "1100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "25",
      quality: "-",
      processing: "カット",
      speed: "1100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "2",
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "350",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "900",
      mode: "-",
      number: "2",
    },
    {
      name: "桐",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "350",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク材",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "竹",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "竹",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "4",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "5",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "革",
      software: "LaserGRBL",
      thickness: "4",
      quality: "-",
      processing: "カット",
      speed: "800",
      max: "900",
      mode: "-",
      number: "5",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "55%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "アルミナ",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "550",
      mode: "-",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ガラス",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "26",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "アクリル",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "26",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "アクリル",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "半透明アクリル",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "半透明アクリル",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "二色板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "二色板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "高密度フォームボード",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "13%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "高密度フォームボード",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "130",
      mode: "-",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ゴム",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "9000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "9000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "9000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "9000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "27%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "270",
      mode: "-",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "彫刻",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "12",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "9",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "11",
      processing: "彫刻",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "12",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "9",
      quality: "-",
      processing: "カット",
      speed: "200",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "彫刻",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "ステンレス鋼板",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "60%",
      mode: "-",
      number: "1",
    },
    {
      name: "ステンレス鋼板",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "EVAフォーム",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "1500",
      max: "30%",
      mode: "-",
      number: "1",
    },
    {
      name: "EVAフォーム",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "カット",
      speed: "1500",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "もち米紙",
      software: "LightBurn",
      thickness: "0.5",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "もち米紙",
      software: "LaserGRBL",
      thickness: "0.5",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "1.5",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "ウールブランケット",
      software: "LaserGRBL",
      thickness: "1.5",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "5000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "カット",
      speed: "5000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "鏡",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "鏡",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "石",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "石",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "クリスタルストーン",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "7000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "クリスタルストーン",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "7000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "8000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "PCB基板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "8000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "ハードメープル材",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ハードメープル材",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "彫刻",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "彫刻",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "3000",
      max: "90%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "彫刻",
      speed: "3000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "鉄板",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "ヘアラインステンレススチール",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "2000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "真鍮",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "レンチ（クロムバナジウム合金）",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "彫刻",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],
  swift7w12w: [
    {
      type: "title",
      content: "AtomStack Swift 7W Laser Parameters",
    },
    {
      name: "シナノキ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "10%",
      mode: "Line",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: "450",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "NA",
    },
    {
      name: "松",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "60%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "松",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "樺",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "樺",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "マホガニー",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "NA",
    },
    {
      name: "マホガニー",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "40%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "桐",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "桐",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "桐",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: "130",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "コルク",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "100%",
      mode: "-",
      number: "6",
    },
    {
      name: "竹",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "革",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "革",
      software: "-",
      thickness: "1mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "デニム",
      software: "-",
      thickness: "0.7mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "NA",
    },
    {
      name: "セラミックス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "セラミックタイル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "黒色アルミナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "黒色アルミナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "ガラス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "ガラス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "-",
      thickness: "2.5mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "5",
    },
    {
      name: "プラスチック",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "-",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "-",
      thickness: "0.1mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "段ボール",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "段ボール",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "MDF",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "75%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "MDF",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "ステンレス鋼",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "ステンレス鋼",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "木の葉",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "木の葉",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "ゴム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "50%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "ゴム",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "10%",
      mode: "Line",
      number: "1",
    },
    {
      name: "フェルト布",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "フェルト布",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "フェルト布",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "NA",
    },
    {
      name: "小石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "小石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "300",
      max: "100%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "鏡",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "鏡",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "Line",
      number: "1",
    },
    {
      name: "石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "30%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "300",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      type: "title",
      content: "AtomStack Swift 12W Laser Parameters",
    },
    {
      name: "シナノキ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "55%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "シナノキ",
      software: "-",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: "110",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "松",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "松",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "50%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "松",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "150",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "松",
      software: "-",
      thickness: "9mm",
      quality: "-",
      processing: "カット",
      speed: "400",
      max: "100%",
      mode: "-",
      number: "8",
    },
    {
      name: "樺",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "50%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "樺",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "マホガニー",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "マホガニー",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "40%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "桐",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "65%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "桐",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "桐",
      software: "-",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "130",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "桐",
      software: "-",
      thickness: "12mm",
      quality: "-",
      processing: "カット",
      speed: "500",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "竹",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "9000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "竹",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "45%",
      mode: "Line",
      number: "1",
    },
    {
      name: "竹",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: "120",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "コルク",
      software: "-",
      thickness: "16mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "100%",
      mode: "-",
      number: "8",
    },
    {
      name: "革",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "20%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "革",
      software: "-",
      thickness: "1mm",
      quality: "-",
      processing: "カット",
      speed: "700",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "デニム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "デニム",
      software: "-",
      thickness: "0.7mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "セラミックス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "600",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "セラミックタイル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "セラミックタイル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "600",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "アルミナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "アルミナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "ガラス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "ガラス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "黒色アクリル",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: "100",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "黒色アクリル",
      software: "-",
      thickness: "10mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "10",
    },
    {
      name: "プラスチック",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "-",
      thickness: "0.5mm",
      quality: "-",
      processing: "カット",
      speed: "1200",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "コピー用紙",
      software: "-",
      thickness: "0.1mm",
      quality: "-",
      processing: "カット",
      speed: "2000",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "段ボール",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "段ボール",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "MDF",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "55%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "MDF",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: "1000",
      max: "100%",
      mode: "-",
      number: "8",
    },
    {
      name: "ステンレス鋼",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "ステンレス鋼",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "木の葉",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "木の葉",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "ゴム",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "10%",
      mode: "Line",
      number: "1",
    },
    {
      name: "フェルト布",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "フェルト布",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "Line",
      number: "NA",
    },
    {
      name: "フェルト布",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "小石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Threshold",
      number: "NA",
    },
    {
      name: "小石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "Line",
      number: "1",
    },
    {
      name: "鏡",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "鏡",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "Line",
      number: "1",
    },
    {
      name: "石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "55%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "Line",
      number: "1",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Jarvis",
      number: "NA",
    },
    {
      name: "亜鉛メッキ鉄",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "NA",
    },
  ],
  swiftmini: [
    {
      name: "シナノキ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "シナノキ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1200",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "松",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1600",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "松",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "600",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "桐",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "桐",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "竹",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "竹",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ブナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ブナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "MDF",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "アルミカード",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "100",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "アルミカード",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "100",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "革",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "革",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ABS樹脂",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ABS樹脂",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "デニム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "100",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "100",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "シリコン",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "シリコン",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "木の葉",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "木の葉",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ガラス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ガラス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "レーザーデバッグ用紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "5000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "レーザーデバッグ用紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "二色板",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "二色板",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ダンボール箱",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ダンボール箱",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "鏡（裏）",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "鏡（裏）",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "柔らかい布",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "4000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "柔らかい布",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "スプレー塗装家具",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "スプレー塗装家具",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ラベル紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "2000",
      max: "100%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ラベル紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "100%",
      mode: "NA",
      number: "1",
    },
    {
      name: "不織布",
      software: "-",
      thickness: "-",
      quality: "1",
      processing: "カット",
      speed: "100",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "A4用紙",
      software: "-",
      thickness: "-",
      quality: "0.12",
      processing: "カット",
      speed: "800",
      max: "100%",
      mode: "-",
      number: "1",
    },
  ],
  AtomStackP1: [
    {
      type: "title",
      content: "AtomStack P1 1.2W Infrared Laser Parameters",
    },
    {
      name: "真鍮",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "1500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "真鍮",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "鉄板",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "3500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "鉄板",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "塗装アルミナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "塗装アルミナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "ブラックアルミナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ブラックアルミナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ステンレススチール",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "3500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ステンレススチール",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "塗装家具",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "5000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "塗装家具",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "65%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ABS樹脂",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ABS樹脂",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "35%",
      mode: "NA",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "革",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "60%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "革",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ブラックアクリル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ブラックアクリル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "50%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "メタル名刺",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "40%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "メタル名刺",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "55%",
      mode: "NA",
      number: "1",
    },
    {
      name: "石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.01",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "500",
      max: "70%",
      mode: "NA",
      number: "1",
    },
    {
      type: "title",
      content: "AtomStack P1 5W Diode Laser Parameters",
    },
    {
      name: "バスウッド",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "9000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "バスウッド",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "黄桃木",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "松",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "5000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "松",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "桐",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "桐",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "竹",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "7000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "竹",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ブナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ブナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "9000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "クラフト紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "MDF",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "アルミカード",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "100",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "アルミカード",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "革",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "革",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "プラスチック",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ゴム",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "デニム",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "200",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "セラミックタイル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "300",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ブラックアルミナ",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ブラックアルミナ",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ガラス",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "800",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ガラス",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "400",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ブラックアクリル",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.05",
      processing: "彫刻",
      speed: "5000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ブラックアクリル",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "25%",
      mode: "NA",
      number: "1",
    },
    {
      name: "二色板",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "二色板",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "8000",
      max: "65%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "段ボール箱",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "鏡",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "3000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "鏡",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "木の葉",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "80%",
      mode: "Stucki(Negative engraving)",
      number: "1",
    },
    {
      name: "木の葉",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "10%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "石",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "石",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "30%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "ステンレススチール",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "1500",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ステンレススチール",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "塗装家具",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "塗装家具",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "レーザーデバッグ用紙",
      software: "ビットマップ",
      thickness: "-",
      quality: "0.08",
      processing: "彫刻",
      speed: "10000",
      max: "10%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "レーザーデバッグ用紙",
      software: "ベクターライン",
      thickness: "-",
      quality: "NA",
      processing: "彫刻",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 120,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "バスウッド",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "カット",
      speed: 120,
      max: "80%",
      mode: "-",
      number: 2,
    },
    {
      name: "松",
      software: "LightBurn",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: 100,
      max: "80%",
      mode: "Stucki",
      number: 2,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "4mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "桐",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 3,
    },
    {
      name: "革",
      software: "LightBurn",
      thickness: "1mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "クラフト紙",
      software: "LightBurn",
      thickness: "0.6mm",
      quality: "-",
      processing: "カット",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "フェルト生地",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "カット",
      speed: 1000,
      max: "80%",
      mode: "-",
      number: 3,
    },
    {
      name: "ウールブランケット",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "カット",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "デニム",
      software: "LightBurn",
      thickness: "0.7mm",
      quality: "-",
      processing: "カット",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "段ボール箱",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "カット",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    }
  ],
};
